import { BillingPlan, ConnectAddOn, ConnectNonTrialBillingPlan } from './stripe';

export const CONNECT_PLAN_FEATURE_MAP: Record<ConnectNonTrialBillingPlan, ConnectAddOn[]> = {
  [BillingPlan.ConnectBasic]: [],
  [BillingPlan.ConnectPro]: [
    ConnectAddOn.CustomIntegrationBuilder,
    ConnectAddOn.HeadlessConnectPortal,
    ConnectAddOn.Monitoring,
    ConnectAddOn.UserMetadata,
    ConnectAddOn.WhiteLabeling,
  ],
  [BillingPlan.ConnectEnterprise]: [
    ConnectAddOn.CustomIntegrationBuilder,
    ConnectAddOn.DynamicFieldMapper,
    ConnectAddOn.HeadlessConnectPortal,
    ConnectAddOn.TaskHistoryAPI,
    ConnectAddOn.Monitoring,
    ConnectAddOn.RoleBasedAccessControl,
    ConnectAddOn.UserMetadata,
    ConnectAddOn.WhiteLabeling,
    ConnectAddOn.WorkflowPermission,
  ],
};
